<template>
  <div class="releaseCabin">
    <el-row class="table" v-if="emptyShow">
      <div class="tableTop dis_f_sb_c">
        <div class="left">我发布的现舱</div>
        <div class="right dis_f_c_c hand">
          <div class="img dis_f_c_c">
            <img class="fit" src="@/images/common/release_icon.png" alt="" />
          </div>
          <div class="title" @click="release">我要发布现舱</div>
        </div>
      </div>
      <!-- 表格 -->
      <div>
        <el-table
          class="el-table--workspace-filter"
          :data="tableData"
          stripe
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column
            prop="updateTimeStr"
            width="160px"
            label="发布时间"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column label="船公司" width="160px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="dis_f_l_c shipping" v-if='scope.row.shippingCode '>
                <img
                  class="fit"
                  :src="
                    scope.row.shippinglogo
                      ? scope.row.shippinglogo
                      : require('@/images/common/shipping.png')
                  "
                  alt=""
                />
                <span>{{ scope.row.shippingCode }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="portstartname"
            label="起始港"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="portendname"
            label="目的港"
            width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="etdStr"
            label="开航日"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="containerTypeStr"
            width="300px"
            label="箱型箱量"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div class="dis_f_l_c status" v-if="scope.row.launchFlag == 2">
                <div class="statusIcon">
                  <el-popover
                    placement="top"
                    width="230"
                    trigger="hover"
                    content="*为了确保信息的有效性，信息的有效时间为24小时，过期后可进入我的进行重新发布"
                  >
                    <i slot="reference" class="el-icon-warning hand"></i>
                  </el-popover>
                </div>
                <div class="statusType">已下架</div>
                <div
                  class="statusRight hand"
                  @click="
                    isShow = true;
                    releaseId = scope.row.id;
                  "
                >
                  (重新发布)
                </div>
              </div>
              <div class="status" v-if="scope.row.launchFlag == 1">
                <span class="transaction">交易中</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="dis_f_l_c">
                <el-button
                  @click="editClick(scope.row.id)"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="deleteOnClick(scope.row.id)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="Fenye dis_f_c_c" v-if="page.total > 0">
          <el-pagination
            background
            :total="page.total"
            :current-page="page.pageNo"
            :page-size="page.pageSize"
            @size-change="handleSizeChange"
            @current-change="inputPageNo"
            layout="prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </div>
    </el-row>
    <!-- 分页 -->
    <div class="empty" v-else>
      <!--  2发布的现舱 -->
      <Empty :type="2" :title="'暂无发布的现舱，赶快去现舱大厅查看有没有适合自己的业务吧~'"></Empty>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      @closed="$emit('close')"
      :visible.sync="isShow"
      custom-class="custom-dialog--small"
      :show-close="false"
    >
      <dialog-close-icon
        class="dialog-close-icon"
        @close="isShow = false"
      ></dialog-close-icon>
      <div class="dialog-wrapper">
        <div class="dialog-title">现舱重新发布</div>
        <div class="dialog-content dis_f_l">
          <div class="dialog-img">
            <img class="fit" src="@/images/expert/warning.png" alt="" />
          </div>
          <div class="dialog-Zi">此操作将会重新发布现舱，是否继续?</div>
        </div>
        <div class="dialog-bottom dis_f_sb_c">
          <div class="cancel dis_f_c_c hand" @click="isShow = false">
            取消发布
          </div>
          <el-button
            class="confirm dis_f_c_c hand"
            :loading="loadingButton"
            @click="againFB"
          >
            确认发布
          </el-button>
        </div>
      </div>
    </el-dialog>
    <space-release-dialog
      v-if="showReleaseSpace"
      @close="showReleaseSpace = false"
      @refresh="refreshSpace"
      :id="releaseId"
    ></space-release-dialog>
     <realname-auth-dialog
      v-if="showRealnameAuth"
      @close="showRealnameAuth = false"
      @refresh="() => {}"
    ></realname-auth-dialog>
  </div>
</template>
<script>
import {
  getMySpacelookWeb,
  byPrimaryKeydelete,
  reissueShippingSpacehall,
} from "@/api/workBench/realSingle";
import Empty from "../components/empty.vue";
import { mapState } from "vuex";
export default {
  name: "releaseCabin",
  components: {
    Empty,
    SpaceReleaseDialog: () => import("./components/space-release-dialog"),
    RealnameAuthDialog: () => import("@/components/realname-auth-dialog"),
  },
  data() {
    return {
      showReleaseSpace: false,
      // 表格
      tableData: [],
      // options
      page: {
        pageNo: 1, //页数
        pageSize: 10, //分页数
        total: 0, //总数
      },
      loading: true, //加载
      isShow: false, //弹框
      emptyShow: true, //空状态
      releaseId: "", //发布id
      loadingButton: false, //重新发布loading
      showRealnameAuth:false,//发布loading
    };
  },
  watch: {},
  computed:{
    ...mapState("user", {
      isAuthentication: (state) => state.isAuthentication,
    }),
  },
  async created() {
    let res;
    //现舱1 询盘2
    let params = {
      spaceType: 1,
      pageSize: this.page.pageSize,
      pageNo: this.page.pageNo,
    };
    res = await getMySpacelookWeb(params);
    if (!res.total || res.total == 0) {
      this.emptyShow = false;
    } else {
      this.emptyShow = true;
      this.tableData = res.rows;
      this.page.total = res.total;
    }
    this.loading = false;
  },
  methods: {
    //  =============================列表接口============================
    async getMySpacelookWeb() {
      // ==========接口调用==========
      let res;
      let params = {
        spaceType: 1, //现舱1 询盘2
        pageSize: this.page.pageSize,
        pageNo: this.page.pageNo,
      };
      this.loading = true;
      try {
        res = await getMySpacelookWeb(params);
        console.log("getMySpacelookWeb", res);
        this.tableData = res.rows;
        this.page.total = res.total;
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    // ==============================表格方法==============================
    //删除
    deleteOnClick(id) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await byPrimaryKeydelete({
            id: id,
          });
          if (+res.code == "1") {
            this.$message({ message: "删除成功", type: "success" });
            this.getMySpacelookWeb();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        })
        .catch(() => {});
    },
    // 重新发布
    async againFB() {
      this.loadingButton = true;
      try {
        let res = await reissueShippingSpacehall({ id: this.releaseId });
        this.loadingButton = false;
        if (+res.code == "1") {
          this.$message({ message: "发布成功", type: "success" });
          this.isShow = false;
          this.getMySpacelookWeb();
        } else {
          this.$message({ message: res.message, type: "error" });
          this.isShow = false;
        }
      } catch (e) {
        this.loadingButton = false;
        console.error(e);
      }
    },
    // ==============================分页==============================
    //改变分页数据量
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getMySpacelookWeb();
    },
    // 当前页码改变
    inputPageNo: function (pageNo) {
      console.log("page chagne:", pageNo);
      this.page.pageNo = pageNo;
      this.getMySpacelookWeb();
    },
    // 发布
    release() {
      // 1 已实名 2 未认证
      if(this.isAuthentication == 1){
        this.releaseId = "";
        this.showReleaseSpace = true;
      }else{
        // 实名认证弹框
        this.showRealnameAuth = true;
      }
    },
    refreshSpace() {
      this.page.pageNo = 1;
      this.getMySpacelookWeb();
    },
    editClick(id) {
      this.releaseId = String(id)
      this.showReleaseSpace = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variable.scss";
.releaseCabin {
  .table {
    width: 100%;
    // 100vh - 导航栏 -底部 -上边距 34
    min-height: calc(
      100vh - #{$workNavbarHeight} - #{$workFooterHeight} - 34px
    );
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 30px;
    .tableTop {
      margin-bottom: 22px;
      .left {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #272a31;
      }
      .right {
        width: 116px;
        height: 32px;
        background: #0081ff;
        // box-shadow: 2px 5px 14px 0px rgba(9, 116, 220, 0.2);
box-shadow:2px 5px 8px 2px rgba(9, 116, 220, 0.1);

        border-radius: 6px;
        .img {
          width: 20px;
          height: 20px;
          background: #ffffff;
          border-radius: 50%;
          margin-right: 6px;
          overflow: hidden;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .title {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
    .shipping {
      img {
        width: 26px;
        height: 26px;
        flex: none;
        margin-right: 6px;
      }
      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #555965;
      }
    }
    .Fenye {
      padding: 40px 0 48px;
    }
    // 状态
    .status {
      .transaction {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #555965;
      }
      .statusIcon {
        font-size: 12px;
        color: #f52032;
        margin-right: 3px;
      }
      .statusType {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #555965;
      }
      .statusActive {
        color: #f52032;
      }
      .statusRight {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: var(--themeColor);
        margin-left: 9px;
      }
      .statusRight:hover {
        text-decoration: underline;
      }
    }
  }
  .dialog-wrapper {
    padding: 38px;
    .dialog-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #373842;
      line-height: 35px;
      margin-bottom: 14px;
    }
    .dialog-content {
      margin-bottom: 60px;
      .dialog-img {
        width: 18px;
        height: 16px;
        margin-right: 7px;
        flex: none;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .dialog-zi {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #555965;
        line-height: 26px;
      }
    }
    .dialog-bottom {
      .cancel {
        width: 237px;
        height: 40px;
        background: var(--themeBg);
        border-radius: 10px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: var(--themeColor);
      }
      .confirm {
        width: 237px;
        height: 40px;
        background: var(--themeColor);
        border-radius: 10px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
}
</style>